// extracted by mini-css-extract-plugin
module.exports = {"brandRed":"#f9423a","baseGray":"#a6a6a6","white":"#fff","black":"#000","errors":"Error_errors__g8Qgz","item":"Error_item__14mjB"};